import cn from 'classnames'
import {
  gradient_brandGradientEnd,
  gradient_brandGradientStart,
} from 'ext-ui/style/colors'
import React, { ComponentProps, useId } from 'react'

type CreditCardGradientIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function CreditCardGradientIcon(
  props: CreditCardGradientIconProps,
) {
  const { className = '', ...rest } = props
  const gradientId = useId()

  return (
    <svg
      className={cn('CreditCardGradientIcon', className)}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    >
      <path
        d="M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z"
        fill={`url(#${gradientId})`}
      />
      <path
        d="M24.6666 12.1666H11.3333C10.4128 12.1666 9.66663 12.9128 9.66663 13.8333V22.1666C9.66663 23.0871 10.4128 23.8333 11.3333 23.8333H24.6666C25.5871 23.8333 26.3333 23.0871 26.3333 22.1666V13.8333C26.3333 12.9128 25.5871 12.1666 24.6666 12.1666Z"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.66663 16.3334H26.3333"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="18"
          y1="0"
          x2="18"
          y2="36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradient_brandGradientStart} />
          <stop offset="1" stopColor={gradient_brandGradientEnd} />
        </linearGradient>
      </defs>
    </svg>
  )
}
